import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import GrupoContext from "../../../context/grupo/grupoContext";
import AuthContext from "../../../context/autentication/authContext";
import SubGrupoContext from "../../../context/subgrupo/subgrupoContext";
import BotonLoading from "../../Buttons/BotonLoading";
import { Button } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "85vh",
    width: "98%",
    marginRight: "5em",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  text: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: "red",
  },
}));

export default function AgregarGrupo({
  init,
  setOpen,
  clienteID,
  grupo,
  nameSg,
  alerta,
  desdeTabla,
}) {
  ////////// estilos ///////////////
  const classes = useStyles();

  ///////////////// variables ////////////////

  const authContext = useContext(AuthContext);
  const { cliente } = authContext;

  const grupoContext = useContext(GrupoContext);
  const { grupos, agregarGrupo, obtenerGrupos } = grupoContext;

  const subgrupoContext = useContext(SubGrupoContext);
  const { subGrupos, agregarSubGrupo } = subgrupoContext;
  const [listaGrupos, setListaGrupos] = useState("");
  const [state, setState] = useState({
    nombre: "",
    cliente: clienteID,
    grupo: grupo ? grupo.id : "",
  });
  const [callback, setCallback] = useState({ msg: "", request: "", status: 0 });

  const listarGrupos = (value) => {
    setListaGrupos(value);
  };

  ///////////////////////////////////////////
  ////////// funciones ///////////////
  useEffect(() => {
    if (desdeTabla) {
      obtenerGrupos(cliente).then((value) => listarGrupos(value.grupos));
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = async (event) => {
    setState({
      ...state,
      grupo: event.target.value,
      /* grupoId: event.target.value */
    });
  };

  const onChange = (e) => {
    setCallback({ cliente: "", estado: "", nombre: "" });
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const onSubmit = () => {
    // Validar que no haya campos vacios
    if (state.nombre.trim() === "") {
      setCallback({
        ...callback,
        msg: "*todos los campos son obligatorios",
      });
    } else {
      setCallback({
        ...callback,
        msg: "",
      });
      agregarSubGrupo({
        nombre: state.nombre,
        grupoId: state.grupo.id ? state.grupo.id : state.grupo
      }).then((value) => finish(value));
    }
    init();
  };

  const close = () => {
    init();
    setOpen(false);
  };

  const finish = (value) => {
    setCallback(value);
    if (nameSg) {
      nameSg(value);
    }
  };
  return (
    <Grid container direction="column" justify="center" alignItems="center">
      {desdeTabla ? (
        <div noValidate autoComplete="off" onSubmit={onSubmit}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="start"
            style={{ width: "400px" }}
          >
            <Grid item xs={10}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="grupo">Grupo</InputLabel>
                <Select
                  variant="outlined"
                  labelId="grupo"
                  fullWidth
                  id="grupo"
                  value={state.grupo}
                  onChange={handleChange}
                  label="grupo"
                >
                  {listaGrupos &&
                    listaGrupos.map((g, index) => (
                      <MenuItem key={index} value={g}>
                        {g.nombre}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={10}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="nombre"
                name="nombre"
                label="Nombre"
                value={state.nombre}
                onChange={onChange}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" justify="center" alignItems="start">
            <Grid item xs={8}>
              {state.nombre ? (
                <BotonLoading
                  texto={"Guardar"}
                  disabled={false}
                  load={alerta}
                  onClick={onSubmit}
                  close={close}
                />
              ) : (
                <BotonLoading
                  texto={"Guardar"}
                  disabled={true}
                  load={alerta}
                  onClick={onSubmit}
                />
              )}
            </Grid>
          </Grid>
        </div>
      ) : (
        <div noValidate autoComplete="off" onSubmit={onSubmit}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="start"
            style={{ width: "400px" }}
          >
            <Grid item xs={10}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="nombre"
                name="nombre"
                label="Nombre"
                value={state.nombre}
                onChange={onChange}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" justify="center" alignItems="start">
            <Grid item xs={8}>
              {state.nombre ? (
                <BotonLoading
                  texto={"Guardar"}
                  disabled={false}
                  load={alerta}
                  onClick={onSubmit}
                  close={close}
                />
              ) : (
                <BotonLoading
                  texto={"Guardar"}
                  disabled={true}
                  load={alerta}
                  onClick={onSubmit}
                />
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </Grid>
  );
}
